import { Box, getVariant, injectStyles } from '@apia/theme';

function getFileExtension(fileName: string) {
  return (fileName.match(/\.?([^.]+)$/) ?? [])[1] ?? '';
}

injectStyles('layout.common.components.fileIcon', {
  '&': {
    fontFamily: 'Arial, Tahoma, sans-serif',
    fontWeight: 300,
    display: 'inline-block',
    width: '24px',
    height: '32px',
    background: '#018fef',
    position: 'relative',
    borderRadius: '2px',
    textAlign: 'left',
    WebkitFontSmoothing: 'antialiased',
    margin: '2px !important',
  },
  '&::before': {
    display: 'block',
    content: '""',
    position: 'absolute',
    top: '0',
    right: '0',
    width: '0',
    height: '0',
    borderBottomLeftRadius: '2px',
    borderWidth: '5px',
    borderStyle: 'solid',
    borderTopColor: 'palette.background.paper',
    borderRightColor: 'palette.background.paper',
    borderBottomColor: 'rgba(255,255,255,.35)',
    borderLeftColor: 'rgba(255,255,255,.35)',
  },
  '&::after': {
    display: 'block',
    content: 'attr(data-extension)',
    position: 'absolute',
    bottom: '0',
    left: '0',
    fontSize: '10px',
    color: '#fff',
    textTransform: 'lowercase',
    width: '100%',
    padding: '2px',
    whiteSpace: 'nowrap',
    overflow: 'hidden',
  },
  '&.xs': { width: '12px', height: '16px', borderRadius: '2px' },
  '&.xs::before': {
    borderBottomLeftRadius: '1px',
    borderWidth: '3px',
  },
  '&.xs::after': {
    content: '""',
    borderBottom: '2px solid rgba(255,255,255,.45)',
    width: 'auto',
    left: '2px',
    right: '2px',
    bottom: '3px',
  },
  '&.sm': { width: '18px', height: '24px', borderRadius: '2px' },
  '&.sm::before': {
    borderBottomLeftRadius: '2px',
    borderWidth: '4px',
  },
  '&.sm::after': { fontSize: '7px', padding: '2px' },
  '&.lg': { width: '48px', height: '64px', borderRadius: '3px' },
  '&.lg::before': {
    borderBottomLeftRadius: '2px',
    borderWidth: '8px',
  },
  '&.lg::after': { fontSize: '11px', padding: '4px 6px' },
  '&.lg.sm': { width: '30px', height: '40px', fontSize: '11px' },
  '&.xl': { width: '96px', height: '128px', borderRadius: '4px' },
  '&.xl::before': {
    borderBottomLeftRadius: '4px',
    borderWidth: '16px',
  },
  '&.xl::after': { fontSize: '24px', padding: '4px 10px' },
  '&.sm.sm': { height: '18px' },
  '&[data-extension=zip], &[data-extension=rar]': {
    background: '#acacac',
  },
  '&[data-extension^=doc], &[data-extension^=docx], &[data-extension^=odt]': {
    background: '#307cf1',
  },
  '&[data-extension^=xls], &[data-extension^=xlsx]': {
    background: '#0f9d58',
  },
  '&[data-extension^=ppt]': { background: '#d24726' },
  '&[data-extension=pdf]': { background: '#e13d34' },
  '&[data-extension=txt]': { background: '#5eb533' },
  '&[data-extension=mp3], &[data-extension=wma], &[data-extension=m4a], &[data-extension=flac]':
    {
      background: '#8e44ad',
    },
  '&[data-extension=mp4], &[data-extension=wmv], &[data-extension=mov], &[data-extension=avi], &[data-extension=mkv]':
    {
      background: '#7a3ce7',
    },
  '&[data-extension=bmp], &[data-extension=jpg], &[data-extension=jpeg], &[data-extension=gif], &[data-extension=png]':
    {
      background: '#f4b400',
    },
});

export const FileIcon = ({
  docName,
  iconSize,
  className,
}: {
  docName: string;
  className?: string;
  iconSize?: 'xs' | 'sm' | 'md' | 'lg' | 'xl';
}) => {
  const extension = getFileExtension(docName);

  return (
    <Box
      className={`file__icon ${className ?? ''} ${iconSize ?? ''}`}
      data-extension={extension}
      {...getVariant('layout.common.components.fileIcon')}
    />
  );
};
